/* eslint-disable */

/**
 * Moves a single "pill" indicator to the currently selected text-variant button,
 * producing the Horizon-style sliding effect where the dark background travels
 * to the newly selected variant.
 *
 * Only applies to listed text buttons (.opt-label--btn); swatches and image
 * swatches keep their original styling.
 */
(function () {
  const SLIDER_CLASS = 'opt-slider';

  function positionSlider(container, animate) {
    const selector = container.closest('.option-selector');
    if (!selector) return;

    const checked = selector.querySelector('.opt-btn:checked');
    let slider = container.querySelector(':scope > .' + SLIDER_CLASS);

    // No selection (pre-selection state): hide the pill.
    if (!checked) {
      if (slider) slider.style.opacity = '0';
      return;
    }

    const label = checked.nextElementSibling;
    if (!label || !label.classList.contains('opt-label--btn')) {
      if (slider) slider.style.opacity = '0';
      return;
    }

    if (!slider) {
      slider = document.createElement('span');
      slider.className = SLIDER_CLASS;
      slider.setAttribute('aria-hidden', 'true');
      container.prepend(slider);
    }

    if (!animate) slider.classList.add('opt-slider--no-transition');

    slider.style.opacity = '1';
    slider.style.width = label.offsetWidth + 'px';
    slider.style.height = label.offsetHeight + 'px';
    slider.style.transform = 'translate(' + label.offsetLeft + 'px, ' + label.offsetTop + 'px)';

    if (!animate) {
      // Re-enable transitions after the initial (jump) placement.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          slider.classList.remove('opt-slider--no-transition');
        });
      });
    }
  }

  function initContainer(container) {
    if (container.dataset.optSliderReady === 'true') return;
    if (!container.querySelector('.opt-label--btn')) return;

    container.dataset.optSliderReady = 'true';
    container.classList.add('has-opt-slider');
    positionSlider(container, false);

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(function () {
        positionSlider(container, false);
      });
      ro.observe(container);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.option-selector__btns').forEach(initContainer);
  }

  // Reposition (with animation) whenever a variant option is chosen.
  document.addEventListener('change', function (evt) {
    const target = evt.target;
    if (!target.classList || !target.classList.contains('opt-btn')) return;

    const container = target.closest('.option-selector__btns');
    if (!container) return;

    if (container.dataset.optSliderReady !== 'true') {
      initContainer(container);
    }
    positionSlider(container, true);
  });

  // Keep the pill aligned when the viewport (and therefore wrapping) changes.
  let resizeRaf;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(function () {
      document
        .querySelectorAll('.option-selector__btns.has-opt-slider')
        .forEach(function (container) {
          positionSlider(container, false);
        });
    });
  });

  function boot() {
    initAll();
    // Fonts can load after first paint and change button widths.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        document
          .querySelectorAll('.option-selector__btns.has-opt-slider')
          .forEach(function (container) {
            positionSlider(container, false);
          });
      });
    }
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  // Handle dynamically injected content (quick-add drawers, theme editor).
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target || document);
  });

  window.addEventListener('load', function () {
    initAll();
  });
})();
